import {
    QRCODE_PAGE_LOADED,
    QRCODE_PAGE_UNLOADED,
    MY_DETAIL_SUBMITTED,
    MY_DETAIL_PAGE_UNLOADED,
    SEND_VERIFICATION_EMAIL,
    BTCQRCODE_PAGE_LOADED,
    ETHQRCODE_PAGE_LOADED,
    CHANGE_PASSWORD_SUBMITTED,
    CHANGE_PASSWORD_UNLOADED,
    CHANGE_PHONE_SUBMITTED,
    CHANGE_PHONE_UNLOADED,
    CHANGE_AVATAR_SUBMITTED,
    CHANGE_AVATAR_UNLOADED,
    VERIFYID_SUBMITTED,
    VERIFYID_PAGE_UNLOADED,
    SECURITY_PAGE_LOADED,
    SECURITY_PAGE_UNLOADED,
    UPDATE_SECURITY,
    TOTP_PAGE_LOADED,
    TOTP_PAGE_UNLOADED,
    TOTP_SUBMIT,
    EVENTS_PAGE_LOADED,
    EVENTS_PAGE_UNLOADED,
    REFRESH_TOKEN_VERSION,
    ASYNC_START
} from '../constants/actionTypes'
export default (state = {}, action) => {
    switch (action.type) {
        case QRCODE_PAGE_LOADED:
            return {
                ...state,
                accounts: action.payload ? action.payload.accounts : null,
            }
        case MY_DETAIL_SUBMITTED:
            return {
                ...state,
                profile_errors: action.error ? action.payload.error : null,
                profile_updated: action.error ? false : true,
                password_errors: null,
                password_updated: null,
                waitSpinActive: false
            };
        case SEND_VERIFICATION_EMAIL:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                waitSpinActive: false,
                updated: false,
                emailsent: action.error ? false : true
            }
        case ETHQRCODE_PAGE_LOADED:
        case BTCQRCODE_PAGE_LOADED:
            return {
                ...state,
                account: action.payload ? action.payload.account : null,
            }
        case CHANGE_PASSWORD_SUBMITTED:
            return {
                ...state,
                password_errors: action.error ? action.payload.error : null,
                password_updated: action.error ? false : true,
                profile_errors: null,
                profile_updated: null,
                waitSpinActive: false
            }
        case CHANGE_PHONE_SUBMITTED:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                updated: action.error ? false : true,
                phone_errors: null,
                sms_requested: false
            }
        case CHANGE_AVATAR_SUBMITTED:
        case VERIFYID_SUBMITTED:
        case TOTP_SUBMIT:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                waitSpinActive: false,
                updated: action.error ? false : true
            }
        case UPDATE_SECURITY:
            return {
                ...state,
                errors: action.error ? action.payload.error : null,
                updated: action.error ? false : (action.payload.user ? true : false),
                codeStatus: action.error ? null : action.payload ? action.payload.code_status : null,
            };
        case TOTP_PAGE_LOADED:
            return {
                ...state,
                totp: action.payload.totp_temp
            }
        case EVENTS_PAGE_LOADED:
            return {
                ...state,
                events: action.payload
            }
        case QRCODE_PAGE_UNLOADED:
        case MY_DETAIL_PAGE_UNLOADED:
        case CHANGE_PHONE_UNLOADED:
        case CHANGE_PASSWORD_UNLOADED:
        case CHANGE_AVATAR_UNLOADED:
        case VERIFYID_PAGE_UNLOADED:
        case SECURITY_PAGE_UNLOADED:
        case TOTP_PAGE_UNLOADED:
        case EVENTS_PAGE_UNLOADED:
            return {};

        case ASYNC_START:
            if (action.subtype === SEND_VERIFICATION_EMAIL || action.subtype === CHANGE_PHONE_SUBMITTED
                || action.subtype === CHANGE_PASSWORD_SUBMITTED
            ) {
                return {
                    ...state,
                    waitSpinActive: true
                }
            }
        default:
            return state;
    }
};
